import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd';
import {
  BulkUploadFilter,
  getSelectList,
  SelectPayload,
  SelectResponse,
} from 'api/dashboard';
import { useCallback, useEffect, useState } from 'react';

//import { FileExcelFilled } from '@ant-design/icons';
import BulkUploadListPage from '../BulkUploadList';
const dateFormat = 'DD/MM/YYYY';

type Props = {
  isLoading: boolean;
  onSubmit: (values: BulkUploadFilter) => Promise<void>;
  reloadByTabChange: boolean;
};
const bulkUploadFilter: BulkUploadFilter = {};
const initSelectResp: SelectResponse = {
  data: [],
};

const Filter = ({ onSubmit, reloadByTabChange }: Props) => {
  const { Option } = Select;
  const [form] = Form.useForm<BulkUploadFilter>();
  const [filter, setFilter] = useState(bulkUploadFilter);
  const [isOpen, setOpen] = useState(false);
  const [statuses, setStatus] = useState(initSelectResp);

  const isAdmin = sessionStorage.getItem('isAdmin');
  useEffect(() => {
    const statusPayload: SelectPayload = {
      SKey: 'BulkUploadStatus',
    };
    getSelectList(statusPayload).then((res) => {
      setStatus(res);
    });

  }, []);

  const handleSubmit = useCallback(
    async (values: BulkUploadFilter) => {
      debugger
      let updatedValues = { ...values };
      setFilter(updatedValues);
    },
    [onSubmit, form, filter]
  );

  function handleReset(_e: any) {
    form.resetFields();
    let updatedFilter = { ...filter };
    updatedFilter = bulkUploadFilter;
    setFilter(updatedFilter);
  }

  function filterClicked(_r: any) {
    const toggle: boolean = isOpen;
    if (toggle) setOpen(false);
    else setOpen(true);
  }

  return (

    <div>
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12">
          <Button
            shape="circle"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 30 30"
              >
                <path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path>
              </svg>
            }
            onClick={filterClicked}
            style={{ float: 'right', margin: 10, zIndex: 1000, border: 0 }}
          />
        </div>
      </div>

      <div className="submission-htmlForm">
        {isOpen ? (
          <Form<BulkUploadFilter>
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            scrollToFirstError
            className="standard-forms"
            initialValues={{
              ['Username']: sessionStorage.getItem('user')?.toString(),
              ['SourceApplicationName']:
                isAdmin != 'true' ? sessionStorage.getItem('source')?.toString() : null,
            }}
          >
            <div>
              <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-4">
                  <div className="input-box">
                    <Form.Item
                      label={'File Id :'}
                      name="bulkUploadFileId"
                      className="fieldTitle"
                    >
                      <InputNumber placeholder={'File Id'} min={1} step={1} />
                    </Form.Item>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4">
                  <div className="input-box">
                    <Form.Item
                      label={'File Name :'}
                      name="fileName"
                      className="fieldTitle"
                    >
                      <Input placeholder={'File Name'} />
                    </Form.Item>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4">
                  <div className="input-box">
                    <Form.Item
                      label={'Request Status :'}
                      name="status"
                      className="fieldTitle"
                    // rules={required}
                    >
                      <Select size="large" placeholder="Select">
                        {statuses.data.map((status) => (
                          <>
                            <Option value={status.SValue}>{status.SText}</Option>
                          </>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-4">
                  <div className="input-box">
                    <Form.Item label={'From :'} name="fromDate" className="fieldTitle">
                      <DatePicker format={dateFormat} />
                    </Form.Item>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4">
                  <div className="input-box">
                    <Form.Item label={'To :'} name="toDate" className="fieldTitle">
                      <DatePicker format={dateFormat} />
                    </Form.Item>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4 col-md-12  ">
                  <div className="input-box">
                    <div style={{ marginTop: '10px', float: 'right' }}>
                      <Button
                        type="primary"
                        onClick={handleReset}
                        style={{ float: 'right', marginRight: '5px' }}
                      >
                        {'CLEAR'}
                      </Button>
                      &nbsp; &nbsp;
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ float: 'right', marginRight: '10px' }}
                      >
                        {'SEARCH'}
                      </Button>
                      &nbsp; &nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        ) : null}
      </div>

      <BulkUploadListPage bulkUploadFilter={filter} onSubmit={handleSubmit} reloadByTabChange={reloadByTabChange} />
    </div>
  );
};

export default Filter;
